import type { SelectOption } from '@/shared/ui/selectTypes';
import { NOTIFICATION_TYPE } from './api';

export const NOTIFICATION_TYPE_OPTIONS: SelectOption[] = [
  { value: NOTIFICATION_TYPE.ALL_CLIENTS, label: 'Для всех клиентов' },
  { value: NOTIFICATION_TYPE.ALL_SERVICES, label: 'Для всех СТО' },
  { value: NOTIFICATION_TYPE.SELECTED_USERS, label: 'Только для указанных пользователей' },
];

export const COUNTRY_OPTIONS: SelectOption[] = [
  { value: '1', label: 'Россия' },
  { value: '22', label: 'Беларусь' },
  { value: '82', label: 'Казахстан' },
];

export const optionLabel = (options: SelectOption[], value: unknown) =>
  options.find((option) => option.value === String(value))?.label;
